import makes from './makes.json'

export const OEM_META = [{}, ...makes].reduce((map,make) => {
  map[make.name.toLowerCase()] = { name: make.name }
  return map
})
